+function($, document) {
	$(document.body).addClass('sn-desktop-processing');
}(jQuery, document);